var _path, _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chevron-right-icon",
    width: 4,
    height: 5,
    viewBox: "0 0 4 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.07976 2.51038L0.0167072 0.801982L1.01051 0L4 2.46865L0.943142 5L0 4.21899L2.07976 2.51038Z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        #chevron-right-icon path {\n            fill: url(#bg); \n        }\n        .dark #chevron-right-icon path {\n            fill: url(#bg-dark);\n        }\n    ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "rotate(174.56)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "4.35%",
    stopColor: "#156AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "111.41%",
    stopColor: "#84B1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg-dark",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "rotate(174.56)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "4.35%",
    stopColor: "#18FFB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "111.41%",
    stopColor: "#0DD99C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.fc31012d65d0dcfb866b31a37cae3840.svg";
export { ForwardRef as ReactComponent };